export default {
	
	 common:{
	   
	disabled:"disabled",
	normal:"normal",
	edit:"edit",
	delete:"delete",
	tip:"tip",
	confirm:"confirm",
	loading:"loading...",
	
	cancel:"cancel",
	nodata:"nodata",
	stop:"stop",
	start:"start",
	modify:"modify",
	submit:"submit",
	action:"action",
	
	deleteSuccess:"delete successfully",
	deleteCancel:"undelete",
	editSuccess:"edit successfully",
	
	save:"save",
	saveSuccess:"save successfully",
	addSuccess:"add successfully",
	
	empty:"empty",
	
	timeout:"Network timeout",
	networkError:"Network connection error",
	
	
	modalForm:"pop-up form",
	
	
  },
	
  login: {
    
   
    usernameTip:"please input your account name!",
    passwordTip:"please input your password!",
	signIn:"sign in",
	copyright:"Copyright",
	successInfo:"sign in successfully",
  },
  
  house:{
	  loadingTip:"loading...",
	  state:"state",
	  volume:"volume(m³)",
	  weight:"weight(ton)",
	  time:"datetime",
	  stateUndone:"monitoring",
	  stateDone:"done",
	  desc:"Note:Red represents the X-axis. Green represents the Z-axis. Blue represents the Y-axis."   
  },
  
  home:{
	  
	  logout:"logout",
	  navigation:"navigation",
	  copyright:"Copyright",
	  logoutTip:"logout successfully!",
	  
  },
  
  user:{
	  
	  addUser:"add user",
	  inputUsername:"please input your username",
	  nodata:"no data",
	  disabled:"disabled",
	  normal:"normal",
	  edit:"edit",
	  changePassword:"change your password",
	  delete:"delete",
	  editUser:"edit user",
	  deleteUser:"delete user",
	  username:"username",
	  password:"password",
	  fullName:"full name",
	  role:"role",
	  phoneNumber:"phone",
	  enabled:"enabled",
	  action:"action",
	  
	  usernameTip:"please input your username",
	  passwordTip:"please input your password",
	  fullNameTip:"please input your full name",
	  roleTip:"choose a role",
	  phoneTip:"please input your phone numbers",
	  state:"state",
	  stateTip:"choose the state",
	  newPassword:"new password",
	  newPasswordTip:"please input new password",
	  confirmPassword:"confirm the password",
	  inputPasswordAgain:"please input new password again",
	  
	  
	  tip:"hint",
	  deleteConfirm:"This operation will permanently delete the user. Do you want to continue?",
	  confirm:"confirm",
	  cancel:"cancel",
	  userDeleteSuccess:"delete the user successfully",
	  deleteCancel:"delete cancelled ",
	  
	  
	  passwordDiffTip:"Entered passwords differ",
	  
	  
	  editPasswordSuccess:"Password changed successfully!",
	  addUserSuccess:"User added successfully!",
	  editSuccess:"edit successfully",
	  userList:"user list",  
	  
	  
  },
  
   timingTask:{
	  
	  schedule:"task scheduling",
	  newSchedule:"add new task",
	  orderByName:"sort by name",
	  inputBarnName:"please input barn name",
	  chooseBarn:"select barn",
	  scheduleType:"task type",
	  hour:"hour",
	  minute:"minute",
	  desc:"description",
	  inputDesc:"please input description",
	  editSchedule:"edit task",
	  day:"day",
	  scheduleId:"id",
	  barnId:"barnID",
	  state:"state",
	  startSuccessTip:"start task successfully",
	  stopSuccessTip:"stop task successfully",
	  deleteConfirm:"This action will permanently delete the task, whether to continue?",
	  addSuccessTip:"add task successfully",  
	  
  },
  
  systemManagement:{

	//仓长(cm)
	warehouseLength:"length(cm)",
	inputWarehouseLength:"please input warehouse length",

	//仓宽(cm)
	warehouseWidth:"width(cm)",
	inputWarehouseWidth:"please input warehouse width",

	//仓高(cm)
	warehouseHeight:"height(cm)",
	inputWarehouseHeight:"please input warehouse height",

	//上锥选择
	warehouseTopCone:"top cone",
	hasTopCone:"has top cone",
	yes:"yes",
	no:"no",
	//请选择是否具有上锥
	selectTopCone:"please select if it has top cone",
	//下锥选择
	warehouseLowerCone:"lower cone",
	hasLowerCone:"has lower cone",

	//上锥高度(cm)
	warehouseTopConeHeight:"top height(cm)",
	inputWarehouseTopConeHeight:"please input warehouse top cone height",

	//端口
	warehousePort:"port",		
	inputWarehousePort:"please input warehouse port",

	//地址位
	warehouseAddress:"address",
	inputWarehouseAddress:"please input warehouse address(1-255)",

	//定时扫描(min)
	warehouseScanTime:"scan time(min)",
	inputWarehouseScanTime:"please input warehouse scan time(minute, pass 0 or not pass, not execute)",

	//定点扫描
	warehouseFixedScan:"fixed scan",
	inputWarehouseFixedScan:"please input warehouse fixed scan time(hh:mm:ss)",
	  
	  barnInfo:"barn details",
	  barnType:"barn type",
	  cubeBarn:"cube",
	  cylinderBarn:"cylinder",
	  hemisphereBarn:"hemisphere",
	  //ip地址
	  warehouseIP:"ip address",
	  inputWarehouseIP:"please input warehouse ip address",
	  cubeLength:"barn length(cm)",
	  inputCubeLength:"please input the barn length",
	  cubeWidth:"barn width(cm)",
	  inputCubeWidth:"please input the barn width",
	  cubeHeight:"barn height(cm)",
	  inputCubeHeight:"please input the barn height",
	  grainDensity:"grain density(kg/m³)",
	  inputGrainDensity:"please input grain density",
	  probeAxisX:"X-axis(cm)",
	  inputProbeAxisX:"Please input the X-axis coordinates",
	  probeAxisY:"Y-axis(cm)",
	  inputProbeAxisY:"Please input the Y-axis coordinates",
	  probeAxisZ:"Z-axis(cm)",
	  inputProbeAxisZ:"Please input the Z-axis coordinates",
	  cylinderRadius:"barn radius(cm)",
	  inputCylinderRadius:"please input barn radius",
	  cylinderHeight:"barn height(mm)",
	  inputCylinderHeight:"Please enter cylinder height, 0 for maximum cone",
	  higherCone:"higher cone(mm)",
	  inputHigherCone:"Please enter higher cone height, 0 for maximum cone",
	  lowerCone:"lower cone(mm)",
	  inputLowerCone:"Please enter lower cone height, 0 for maximum cone",
	  lowerConeRadius:"lower radius(cm)",
	  inputLowerConeRadius:"Please enter lower cone radius",
	  lowerHoleRadius:"lower hole radius(cm)",
	  inputLowerHoleRadius:"Please enter lower hole radius",
	  boundaryGap:"boundary gap(cm)",
	  inputBoundaryGap:"Please enter boundary gap, default 50cm",
	  volumeCheck:"volume check(0.1m³)",
	  inputVolumeCheck:"please input volume check",
	  areaCheck:"area check(0.1㎡)",
	  inputAreaCheck:"please input area check",
	  minimumAngle:"minimum angle(0.1°)",
	  inputMinimumAngle:"please input minimum angle",
	  maximumAngle:"maximum angle(0.1°)",
	  inputMaximumAngle:"please input maximum angle",
	  editPorbeIP:"edit porbe IP",
	  inputPort:"please input port",
	  inputIp:"please input IP",
	  gateway:"gateway",
	  inputGateway:"please input gateway",
	  broadcast:"broadcast",
	  inputBroadcast:"please input broadcast address",
	  readSuccess:"read successfully",

    installAngle:"installAngle",
	  horizontal:"x-angle(°):",
	  vertical:"y-angle(°):",
	  angleAdjust:"angleAdjust",
	  readParams:"readParams",
	  saveParams:"saveParams",
	  
	  searchDevices:"search devices",
	  ipScope:"ip scope：",
	  portNumber:"port：",
	  
	  searchSuccess:"search successfully",
	  searchFail:"search failed! check the device state please!",
	  
  },
  
 
  
  warehouseInfo:{
	  
	  //异常数据
	  exceptionData:"exception data",

	  getPoints:"get points",
	  //异常监测开关
	  exceptionMonitor:"exception monitor",
	  //请选择是否启动异常监测
	  exceptionMonitorTip:"please select whether to start exception monitoring",
	  //API开关
	  apiStatus:"API switch",
	  //请选择是否开启API
	  apiStatusTip:"please select whether to enable API",
	  //API端口
	  apiPort:"API port",
	  //请输入API端口（纯数字，非必填）
	  apiPortTip:"please input numeric API port",
	  //高度阈值(米)
	  threshold:"threshold(meters)",
	  inputThreshold:"please input threshold(meters)",
	  //最小异常面积(㎡)
	  minArea:"minimum exception area(square meters)",
	  inputMinArea:"please input minimum exception area(square meters)",
	  //网格分辨率(米)
	  gridResolution:"grid resolution(meters)",
	  inputGridResolution:"please input grid resolution(meters)",
	  //探头臂长(米)
	  probeArmLength:"probe arm length(meters)",
	  inputProbeArmLength:"please input probe arm length(meters)",
	  //探头X坐标(米)
	  probeAxisX:"probe axis X(meters)",
	  inputProbeAxisX:"please input probe axis X(meters)",
	  //探头Y坐标(米)
	  probeAxisY:"probe axis Y(meters)",
	  inputProbeAxisY:"please input probe axis Y(meters)",
	  //探头Z坐标(米)
	  probeAxisZ:"probe axis Z(meters)",
	  inputProbeAxisZ:"please input probe axis Z(meters)",
	  //坐标调试
	  coordinateDebug:"coordinate debug",
	  
	  barnList:"barn list",
	  addBarn:"add barn",
	  inputBarnNumber:"please input barn ID",
	  radarConfig:"radar config",
	  radarParamConfig:"radar param config",
	  restartDevice:"restart",
	  editBarn:"edit barn",
	  barnNumber:"barn ID",
	  barnName:"barn name",
	  barnType:"type",
	  keeper:"keeper",
	  inputBarnName:"please input barn name",
	  chooseBarnType:"please choose barn type",
	  cubeBarn:"cube",
	  cylinderBarn:"cylinder",
	  modelingType:"model type",
	  chooseModelingType:"please choose a model type",
	  originalPoints:"original",
	  fill:"fill",
	  chooseStructure:"please choose the structure",
	  barnLenght:"barn length(cm)",
	  inputBarnLength:"please input the barn length",
	  barnWidth:"barn width(cm)",
	  inputBarnWidth:"please input the barn width",
	  barnHeight:"barn height(cm)",
	  inputBarnHeight:"please input the barn height ",
	  barnConeHeight:"cone height(cm)",
	  inputBarnConeHeight:"please input the cone height",
	  //fc cone height
	  fcConeHeight:"cube cone length(cm)",
	  inputFcConeHeight:"please input cube cone length",
	  //fc cone width
	  fcConeWidth:"cube cone width(cm)",
	  inputFcConeWidth:"please input cube cone width",
	  chooseKeeper:"please choose the keeper",
	  planVolume:"plan volume(m³)",
	  inputPlanVolume:"please input the plan volume",
	  actualVolume:"actual volume(m³)",
	  inputActualVolume:"please input actual volume",
	  deviceType:"device type",
	  inputDeviceType:"please input device type",
	  v2:"2.0",
	  v1:"1.0",
	  grainType:"grain type",
	  chooseGrainType:"please input the grain type",
	  corn:"corn",
	  wheat:"wheat",
	  sorghum:"sorghum",
	  rice:"rice",
	  bean:"bean",
	  paddy:"paddy",
	  millet:"millet",
	  other:"other",
	  dedusting:"dedusting",
	  chooseDedusting:"Please select whether the dust removal function is enabled",
	  yes:"yes",
	  no:"no",
	  axisX:"X-axis",
	  inputAxisX:"Please input the X-axis coordinates",
	  axisY:"Y-axis",
	  inputAxisY:"Please input the Y-axis coordinates",
	  axisZ:"Z-axis",
	  inputAxisZ:"Please input the Z-axis coordinates",
	  inputIP:"please input IP",
	  deviceIP:"device IP",
	  inputDeviceIP:"please input device IP",
	  devicePort:"port",
	  inputDevicePort:"please input device port",
	  username:"username",
	  inputUsername:"please input the username",
	  password:"password",
	  inputPassword:"please input the password",
	  sshPort:"SSH port",
	  inputSshPort:"please input the SSH port",
	  deviceRestartSuccess:"restart successfully",
	  deleteBarnTip:"This operation will permanently delete the barn. Do you want to continue?",
	  radarConfigSuccess:"radar config successfully",


	  cubeParams:"cube params",
	  cubeLength:"cube length(cm)",
	  cubeWidth:"cube width(cm)",
	  cubeHeight:"cube height(cm)",
	  cubeCone:"cone height(cm)",
	  cylinderParams:"cylinder params",
	  cylinderHeight:"cylinder height(mm)",
	  cylinderCone:"cone height(mm)",
	  cylinderRadius:"cylinder radius(cm)",

	  //筒仓半径cm
	  cylinderRadius1:"cylinder radius(cm)",
	  //筒仓高mm：
	  cylinderHeight1:"cylinder height(mm)",
	  //上锥高mm：
	  cylinderCone1:"cylinder cone(mm)",
	  //下锥高mm：
	  cylinderConeDown1:"cylinder cone down(mm)",
	  //下锥半径cm：
	  cylinderRadiusDown1:"cylinder radius down(cm)",

	  //Cylinder Shape
	  cylinderShape:"Cylinder Shape",
	  chooseCylinderShape:"Please choose cylinder shape",
	  bothCones:"Both Top & Bottom Cones",
	  onlyTopCone:"Only Top Cone",
	  onlyBottomCone:"Only Bottom Cone",
	  noCones:"No Cones",

	  //探头坐标：
	  probeCoordinates:"probe coordinates",
	  //X坐标
	  probeAxisX:"axisX",
	  //Y坐标
	  probeAxisY:"axisY",
	  //Z坐标
	  probeAxisZ:"axisZ",

	  //安装角度
	  probeInstallAngle:"probe install angle",
	  //水平角度
	  probeHorizontalAngle:"probe horizontal angle",
	  //垂直角度
	  probeVerticalAngle:"probe vertical angle",
	  //角度校准
	  probeAngleCalibration:"probe angle calibration",
	  //读取参数
	  probeReadParameter:"probe read parameter",
	  //保存参数
	  probeSaveParameter:"probe save parameter",
	  


    alarmFunction:"alarm_func",
    checkFunction:"whether there is an alarm function",

    grainDensity:"density(kg/m³)",
    grainDensityInput:"please input grain density,default value is 1.0",
    property:"property",
    propertyInput:"please input the property of the barn",

    harvestYear:"harvestYear",
    harvestYearInput:"please input the harvest year",
    level:"level",
    levelInput:"please input the level",
    validity:"validity(%)",
    validityInput:"please input the validity",
	  
	  
  },
  
  system:{

      screenShowBarn:"Large-screen show barn",
      chooseBarn:"please choose a barn",
      checkPushAddress:"check push address",
      inputCheckPushAddress:"please input the check push address",
      scanPushAddress:"scan push address",
      inputScanPushAddress:"please input the scan push address",
      exceptionPushAddress:"abnormal push address",
      inputExceptionPushAddress:"Please input the abnormal push address",
      sensorPushAddress:"cable data push address",
      inputSensorPushAddress:"please input the cable data push address",
      companyLogo:"company logo",
      upload:"upload",
      systemName:"system name",
      inputSystemName:"please input system name",
      companyName:"company name",
      inputCompanyName:"please input company name",
      versionNumber:"version number",
      inputVersionNumber:"Please input the version number",
      inputCompanyLogo:"Please upload company logo",
      pointCloudPath:"point cloud file path",
      inputPointCloudPath:"please input point cloud file path",
  },
  
  rbac:{
	  
	  authorization:"authorization",
	  grantPermission:"grant",
	  screen:"large-screen",
	  homePage:"home page",
	  detection:"detection",
	  historicalData:"historical data",
	  history:"history",
	  alarmRecord:"alarm record",
	  barnList:"barn list",
	  cameraManage:"camera management",
	  userManage:"user management",
	  schedule:"scheduler",
	  systemManage:"system management",
	  permissionManage:"pemission",
	  roleManage:"role management",
	  menuManage:"menu management",
	  chooseMenuItem:"Please select at least one menu!",
	  grantSuccess:"grant successfully",
	  login:"login",
	  barnDisplay:"display barn",
    singleBarnDisplay:"single barn",
    playback:"playback",
    cameraView:"camera preview",
    radarConfig:"radar config",
	  
	  
	  addMenu:"add menu",
	  editMenu:"edit menu",
	  menuName:"menu name",
	  menuType:"menu type",
	  permissionID:"permission ID",
	  visitPath:"path",
	  orderID:"order",
	  icon:"icon",
	  parentMenu:"parent menu",
	  chooseParentMenu:"please choose parent menu",
	  inputMenuName:"please input menu name",
	  inputPermissionID:"please input permission name",
	  inputVisitPath:"please input path",
	  inputOrderID:"please input order ID",
	  inputNumberTip:"Please enter a number between 1 and 100",
	  inputIcon:"please input the icon",
	  deleteTip:"This action permanently deletes the menu. Do you want to continue?",
	  deleteMenuSuccess:"delete menu successfully",
	  addMenuSuccess:"add menu successfully",
	  menuList:"menu list",
	  empty:"empty",
	  
	  
	  addRole:"add role",
	  editRole:"edit role",
	  roleName:"role name",
	  roleID:"role ID",
	  roleDesc:"description",
	  admin:"admin",
	  inputRoleName:"please input role name",
	  inputRoleID:"please input role ID",
	  inputRoleDesc:"please input role description",
	  deleteRoleTip:"This action permanently deletes the role. Do you want to continue?",
	  deleteRoleSuccess:"delete successfully",
	  addRoleSuccess:"add successfully",
	  
  },
  
  detection:{
    //Historical Data
    historyData:"Historical Data",
    //Historical Curve
    historyCurve:"Historical Curve",

	//温度(℃)
	temperature:"temperature(℃)",
	//湿度(%)
	humidity:"humidity(%)",


	//库存数量(吨)
	stockQuantity:"stock quantity(ton)",
	//检测数量
	detectionQuantity:"detection quantity(ton)",
	//差异数量(吨)
	differenceQuantity:"difference quantity(ton)",
	//差异率(%)
	differenceRate:"difference rate(%)",

	//待补仓数量(吨)
	differenceQuantity:"pending warehouse quantity(ton)",

	//未记账数量(吨)：
	differenceQuantity:"unrecorded quantity(ton):none",

	//粮面平整度
	grainSurfaceFlatness:"grain surface flatness: normal",

	//粮面异动
	grainSurfaceDeviation:"grain surface deviation: none",

	//仓房基本信息
	barnBasicInfo:"barn basic info",
	//仓房名称
	barnName:"barn name",
	//物料种类
	grainType:"grain type",

	

	  
	  online:"online",
	  offline:"offline",
	  barnID:"barnID",
	  stock:"stock",
	  ton:"ton",
	  stockVolume:"volume",
	  stockWeight:"weight",
	  grainType:"grain",

    singleHeight:"grainHeight",
	  
	  
	  alarmLogs:"alarm logs",
	  start:"start",
	  end:"end",
	  all:"all",
	  magneticAlarm:"magnetic alarm",
	  infraredAlarm:"infrared alarm",
	  helpAlarm:"help alarm",
	  inputBarnID:"please input barn ID",
	  exportExcel:"export data",
	  clearAlarm:"clear alarm",
	  alarmInfo:"alarm details",
	  alarmTime:"alarm time",
	  clearSuccess:"clear alarm successfully",
	  clearFail:"clear alarm failed",
	  deteleAlarmSuccess:"This operation will permanently delete this record, whether to continue?",
	  
	  
	  historicalData:"historical data",
	  loading:"loading...",
	  validPoints:"Number of valid test points:",
	  operator:"operator：",
	  status:"status：",
	  checking:"checking",
	  done:"done",
	  deviceOffline:"offline",
	  scanFailed:"scan failed",
	  validCheck:"valid check：",
	  valid:"valid",
	  invalid:"invalid",
	  errorCode:"error code：",
	  volume1:"volume(m³)：",
	  height:"height(m)：",
	  averageHeight:"average height(m)：",
	  highestPoint:"highest point(m)：",
	  lowestPoint:"lowest point(m)：",
	  scanTimes:"scan times：",
	  datetime:"datetime：",
	  scanType:"scan type：",
	  auto:"auto",
	  manual:"manual",
	  validScanPoints:"valid scan points：",
	  probeError:"probe error：",
	  normal:"normal",
	  error:"error",
	  weight:"weight(ton)：",
	  defenceState:"state of defence：",
	  defend:"defend",
	  undefend:"undefend",
	  alarm:"alarm",
	  alarmState:"state of alarm：",
	  infraredDefendState:"state of infrared defence：",
	  infraredAlarmState:"state of infrared alarm：",
	  helpAlarmState:"state of help alarm：",
	  desc:"Note:Red represents the X-axis. Green represents the Z-axis. Blue represents the Y-axis.",
	  
	  
	  singleBarnDisplay:"single barn",
	  collectionProgress:"collect progress",
	  startScan:"start scan",
	  stopScan:"end scan",
	  queryState:"query state",
	  clearDust:"clear dust",
	  historicalDataRecord:"historic data",
	  threeD:"3D",
	  downloading:"downloading...",
	  offlineTip:"The device is not online! Please check whether the equipment is normal!",
	  operateSuccess:"operate successfully",
	  operateFail:"operate failed",
	  browserCheckTip:"Your browser does not support WebSocket",
	  idle:"idling...",
	  scanning:"scanning...",
	  scanFailTip:"Scan failed, error code",
	  scanDone:"scan done",
    deviceOff:"device offline...",
	  scanException:"scan exception",
	  loadingData:"data loading...",
	  scanPause:"scan pause",
	  scanningTip:"under scan",
	  magneticDefend:"magnetic defence：",
	  on:"on",
	  off:"off",
	  magneticAlarmState:"state of megnetic alarm：",
	  infraredDefend:"infrared defence：",
	  
	  
	  detection:"detection control",
	  selectOrder:"order by：",
	  orderByTime:"by time",
	  orderByName:"by name",
	  orderByOnline:"by online",
	  orderByOffline:"by offline",
	  inputBarnID:"please input barn ID",
	  invertSelect:"invert",
	  allSelect:"all",
	  scanControl:"scan",
	  chooseBarnTip:"Please select at least one barn",
	  
	  
	  
	  dataRecord:"data records",
	  barnVolume:"volume(m³)",
	  detectStart:"start",
	  detectEnd:"end",

    detectionInfo:"detection info",
    amount:"amount(ton)",
    barnInfo:"barn details",
    barnType:"type",
    volume:"volume(ton)",
    variety:"variety",
    property:"property",
    harvestYear:"harvest year",
    level:"level",


	//数据(m)
	data:"data(m)",
	//错误码
	errorCode:"error code",
	//状态码
	statusCode:"status code",

	//远程控制
	remoteControl:"remote control",

	//测距
	measure:"measure",

	//扫描筛选
	scanFilter:"scan filter",

	//timing
	timing:"timing",
	//定点
	point:"point",

	//日报表
	report:"daily report",
	//周报表
	weekReport:"weekly report",
	//月报表
	monthReport:"monthly report",
	//历史曲线
	historicalCurve:"historical curve",
	//选择仓房
	selectBarn:"select barn",
	//搜索
	search:"search",

	//数据(mm)
	dataMM:"data(mm)",

	//测量时间
	measureTime:"measure time",
	//请至少选择一条记录进行删除！
	selectRecordDelete:"Please select at least one record to delete!",
	//请选择一个仓房！
	selectBarnTip:"Please select a barn!",

    monitor:"monitor",
    reports:"reports",

    // Grain Inspection Report
    grainInspectionReport:"Grain Inspection Worksheet",
    companySeal:"Company (Seal): ",
    measurementDate:"Measurement Date: ",
    cargoLocation:"Cargo Location",
    nature:"Nature",
    harvestYear:"Harvest Year",
    storageForm:"Storage Form",
    accountQuantity:"Account Quantity(kg)",
    qualityGrade:"Quality Grade",
    entryMethod:"Entry Method",
    grainBarn:"Grain Barn",
    entrustedStorage:"Entrusted Storage",
    grainInboundQuality:"Grain Inbound Quality",
    bulkDensity:"Bulk Density(g/l)",
    measuredGrainQuality:"Measured Grain Quality",
    moisture:"Moisture(%)",
    impurity:"Impurity(%)",
    calculateGrainVolume:"1. Calculate Grain Volume",
    grainShapeDimensions:"Grain Shape & Dimensions",
    chart:"(Chart)",
    measuredGrainVolume:"Measured Grain Volume(m³)",
    deductVolume:"Deduct Volume(m³)",
    actualGrainVolume:"Actual Grain Volume(m³)",
    calculateAvgDensity:"2. Calculate Avg Density",
    standardContainerMethod:"Standard Container□",
    grainBulkDensity:"Grain Bulk Density",
    correctedFactor:"Corrected Factor",
    avgGrainDensity:"Avg Grain Density",
    specialContainerMethod:"Special Container□",
    unitVolumeWeight:"Unit Volume Weight",
    kgPerCubicMeter:"(kg/m³)",
    calculateGrainQuantity:"3. Calculate Grain Quantity",
    confirmActualQuantity:"4. Confirm Actual Quantity",
    calculatedQuantity:"Calculated Quantity(kg)",
    compareWithAccount:"Compare with Account",
    difference:"Difference(kg)",
    lossRate:"Loss Rate(%)",
    grainLoss:"Grain Loss(kg)",
    moistureLoss:"Moisture Loss",
    storageLoss:"Storage Loss",
    total:"Total",
    accountMatch:"Account Match",
    no:"No",
    actualGrainQuantity:"Actual Grain Quantity(kg)",

    validity:"validity(%)",
    isValid:"isValid",

    // Stock Statistics
    stockStatistics:"Stock Statistics",
    stockList:"Stock List",
    inputBarnName:"Please input barn name",
    materialName:"Material Name",
    grainType:"Grain Type",
    stockVolume:"Stock Volume(m³)",
    scanTime:"Scan Time",
    exportSuccess:"Export Success",
    viewDetail:"View Detail",

    // Change Statistics
    changeStatistics:"Change Statistics",
    changeList:"Change Record List",
    allTypes:"All Types",
    changeType:"Change Type",
    changeDensity:"Density Change",
    changeGrainType:"Grain Type Change",
    barnOffline:"Barn Offline",
    beforeValue:"Before Value",
    afterValue:"After Value",
    operator:"Operator",
    changeTime:"Change Time",
    remark:"Remark",

    // Big Screen Category Weight Statistics
    categoryWeightStats:"Category Weight Statistics",
    onlineOfflineStats:"Online/Offline Statistics",
    weightTrend:"Weight Trend",
    unknown:"Unknown",
    ton:"ton",

    // Big Screen Grid Component
    stockPercent:"Stock Percentage",
    materialType:"Material Type",
	 
	  
  },
  
  historicalVideo:{
	  
	  playback:"playback",
	  chooseTime:"choose time：",
	  chooseStart:"please choose the start time",
	  chooseEnd:"please choose the end time",
	  query:"query",
	  loading:"data loading...",
	  start:"start：",
	  end:"end：",
    temperature:"temperature",
    humidity:"humidity",
	  
  },
  
  camera:{
	  
	  pictureLoading:"picture loading...",
	  ptzControl:"PTZ control",
	  focalLength:"focal length",
	  lensMove:"lens move",
    brand:"brand",
	  
	  login:"login",
	  preview:"preview",
	  start:"start",
	  end:"end",
	  playback:"playback",
	  loginSuccess:"login successfully",
	  loginFail:"Login failed. Please check the IP, port, username and password.",
	  missingDeviceInfo:"Please fill in the device IP and port first!",
	  notLogin:"Please log in to the device first!",
	  noChannel:"No video channels found. Please wait or log in again!",
	  getChannelFail:"Failed to get video channels!",
	  selectTimeRange:"Please select the playback start and end time!",
	  previewSuccess:"preview successfully",
	  previewFail:"Preview failed, please check whether to log in!",
	  supportWebsockitTip:"The device does not support Websocket stream access. You can query the device ip address in the browser!",
	  startPlaybackSuccess:"Start playback successfully!",
	  notSupportWebsockit:"The device does not support Websocket stream fetching!",
	  startPlaybackFail:"start playback failed!",
	  
	  
	  addCamera:"add camera",
	  inputBarnID:"please input barn ID",
	  pictureCheck:"Picture viewing",
	  editCamera:"edit camera",
	  barnID:"barnID",
	  type:"type",
	  name:"name",
	  linkType:"link type",
	  username:"username",
	  password:"password",
	  barn:"barn",
	  chooseBarn:"please choose a barn",
	  deviceType:"device type",
	  chooseDeviceType:"please choose device type",
	  camera:"camera",
	  vcr:"vcr",
	  chooseLinkType:"please choose link type",
	  ez:"ez",
	  localNet:"local net",
	  inputName:"please input the name",
	  inputUsername:"please input the username",
	  inputPassword:"please input the password",
	  ipAddr:"IP address",
	  inputIpAddr:"please input ip address",
	  port:"port",
	  inputPort:"please input the port",
	  deleteCameraTip:"This operation will permanently delete the camera, whether to continue?",
	  deleteSuccess:"delete camera successfully",
	  addSuccess:"add camera successfully",
	  
	  
  },
  
  
  screen:{
	  
	  
	  totalStorage:"total storage",
	  id:"id",
	  barnID:"barnID",
	  volume:"volume",
	  start:"start",
	  end:"end",
    lgz:"height",
    weight:"weight",
    weightSingle:"weight(t)",
	  
	  
	  entrySystem:"entry system",
	  curTotalStorage:"current storage(ton)",
	  totalDevices:"online/offline(%)",
	  storageChange:"storage change(m³)",
	  dynamicData:"dynamic data",
	  useRatio:"use ratio",
	  
  },
  
  components:{
	  
	  outline:"outline",
	  reset:"reset",
    heatmap:"heatmap",
    grainPlane:"plane",
    pointCloud:"points",
	//俯视图
    topView:"top view",
	//显示仓房外框
    outline:"show outline",
	//层级过滤
    layerFilter:"layer filter",
	//层级过滤
    layer:"layer",
	//查看全部
    viewAll:"view all",
	//线缆-传感器列表
    sensorList:"sensor list",
	//仓库信息
    warehouseInfo:"warehouse info",
	//仓号
    warehouseID:"warehouse ID",
	//平均湿度
    averageHumidity:"average humidity",
	//平均水分
    averageMoisture:"average moisture",
	//最高水分
    highestMoisture:"highest moisture",
	//最低水分
    lowestMoisture:"lowest moisture",
	//最高温度
    highestTemperature:"highest temperature",
	//最低温度
    lowestTemperature:"lowest temperature",
	//粮食种类
    foodType:"food type",
	//无数据
    noData:"no data",

	//温度上限
    temperatureUpperLimit:"temperature upper limit",
	//温度下限
    temperatureLowerLimit:"temperature lower limit",
	//温度超限
    temperatureExceeded:"temperature exceeded",
	//水分上限
    humidityUpperLimit:"humidity upper limit",
	//水分下限
    humidityLowerLimit:"humidity lower limit",
	//水分超限
    humidityExceeded:"humidity exceeded",

	//正常范围内
    normalRange:"normal range",
	//超出上下限但在超限值内
    exceededRange:"exceeded range but within limit",
	//超出超限值
    exceededLimit:"exceeded limit",
	//选中状态
    selected:"selected",
	//超出上下限
    exceededRange1:"exceeded range",
	//正常
    normal:"normal",


	//采集时间
    collectTime:"collect time",
	//传感器详情
    sensorDetail:"sensor detail",
	//缆号
    cableID:"cable ID",
	//传感号
    sensorID:"sensor ID",
	//温度
    temperature:"temperature",
	//水分
    moisture:"moisture",
	//M值
    mValue:"M value",
	//缆号/传感号
    cableSensorID:"cable ID/sensor ID",
	//缺少仓库ID参数
	missingWarehouseID:"missing warehouse ID parameter",
	//获取仓库数据失败
    getWarehouseDataFailed:"get warehouse data failed",
	//获取仓库数据出错
	getWarehouseDataError:"get warehouse data error",
	//至少需要选择一个层级
    atLeastOneLayer:"at least one layer is required",
	//初始化3D视图出错
    init3DViewError:"initialize 3D view failed",
  },
  
  //消息提示
  message:{
    setLanguageSuccess:"Set language success"
  },
  //菜单相关
  menus:{
    deviceManage:"Device Manage"
  }
}
